var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApproval(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.086,
    height: 32,
    viewBox: "0 0 35.086 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Approval_enable",
    transform: "translate(-638.453 -171.453)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_482",
    "data-name": "Group 482",
    transform: "translate(638.453 171.453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2754",
    "data-name": "Path 2754",
    d: "M664.321,171.456c0,.077.01.155.01.232q0,4.614,0,9.227c0,.048,0,.1,0,.143,0,.09-.036.132-.132.116a12.424,12.424,0,0,0-2.334-.124c-.1,0-.157-.039-.157-.145,0-.06,0-.119,0-.179q0-3.281,0-6.563c0-.267,0-.267-.263-.267h-20.03c-.276,0-.277,0-.277.274q0,13.26,0,26.519c0,.266,0,.266.266.266q5.937,0,11.875,0a.559.559,0,0,1,.452.189,11.718,11.718,0,0,0,2.68,2.125c.044.025.1.04.113.107-.053.056-.122.032-.183.032h-17.7c-.059,0-.119-.006-.178-.009q0-15.891,0-31.782c0-.134.03-.164.164-.164Q651.469,171.458,664.321,171.456Z",
    transform: "translate(-638.453 -171.453)",
    fill: "#4672ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2755",
    "data-name": "Path 2755",
    d: "M856.684,338.918a10.327,10.327,0,0,1-2.725,7.289,10,10,0,0,1-6.1,3.275,10.243,10.243,0,0,1-8.442-2.355,10.366,10.366,0,0,1,4.679-18.013,10.545,10.545,0,0,1,12.338,7.9A8.25,8.25,0,0,1,856.684,338.918Zm-11.8,6.345a1.4,1.4,0,0,0,1.01-.3c.168-.152.334-.306.495-.466q3.094-3.077,6.227-6.113a2.731,2.731,0,0,0,.594-.907.593.593,0,0,0-.086-.656,10.224,10.224,0,0,0-.869-.9.831.831,0,0,0-1.111-.1,3.457,3.457,0,0,0-.619.483q-2.094,2.053-4.188,4.106a1.651,1.651,0,0,1-.785.474.624.624,0,0,1-.636-.184c-.46-.492-.924-.98-1.364-1.49-.276-.32-.548-.647-.851-.941a.958.958,0,0,0-1.415-.051c-.4.379-.782.785-1.194,1.156a.924.924,0,0,0-.2,1.133,2.21,2.21,0,0,0,.337.5c.5.584,1.039,1.133,1.568,1.691.693.731,1.364,1.483,2.109,2.163A1.33,1.33,0,0,0,844.882,345.263Z",
    transform: "translate(-821.6 -317.614)",
    fill: "#4672ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2756",
    "data-name": "Path 2756",
    d: "M715.876,279.317h7.671c.3,0,.3,0,.3.306,0,.858,0,1.716,0,2.574,0,.179-.052.238-.232.238q-7.733-.006-15.467,0c-.218,0-.234-.016-.234-.234q0-1.314,0-2.628c0-.24.013-.252.253-.252Z",
    transform: "translate(-702.941 -271.591)",
    fill: "#4672ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2757",
    "data-name": "Path 2757",
    d: "M712.343,363.205h-4.2c-.253,0-.255,0-.255-.243,0-.876,0-1.752,0-2.628,0-.167.049-.228.224-.228q4.237.007,8.474,0c.176,0,.223.064.222.23-.006.876,0,1.752,0,2.628,0,.238,0,.241-.238.241Z",
    transform: "translate(-702.911 -346.593)",
    fill: "#4672ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2758",
    "data-name": "Path 2758",
    d: "M710.462,440.971c.781,0,1.562,0,2.343,0,.159,0,.221.043.219.211q-.01,1.341,0,2.682c0,.155-.05.208-.206.208q-2.361-.006-4.721,0c-.162,0-.2-.066-.2-.213q.006-1.341,0-2.682c0-.153.051-.208.208-.206C708.889,440.974,709.675,440.971,710.462,440.971Z",
    transform: "translate(-702.92 -421.663)",
    fill: "#4672ba"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproval);
export default __webpack_public_path__ + "static/media/Approval.258b396b.svg";
export { ForwardRef as ReactComponent };